module.exports = __webpack_public_path__ + "img/suitcase.1ca267ee.svg";